<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}生产厂商维护</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">旧生产厂家基础信息</span>
          </div>
          <el-row>
            <el-col :class="!getIsView()?'viewCol':''" :span="4">
              <el-form-item v-if="getIsView()" label="生产厂商编号" prop="no">
                <el-input disabled v-model="form.no" style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>生产厂商编号: {{ form.no }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="生产厂家名称" prop="oldName">
                <el-input v-model="form.oldName" disabled style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>生产厂家名称: {{ form.oldName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="生产厂家类型" prop="oldCategory">
                <el-select v-model="form.oldCategory" disabled multiple style="width: 90%;">
                  <el-option v-for="item in ManufacturerCategoryOptions" :key="item.id" :label="item.name + '厂商'" :value="item.name + '厂商'"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>生产厂家类型: {{ form.oldCategory.join(';') }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="联系人" prop="oldContactor">
                <el-input v-model="form.oldContactor" disabled style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>联系人: {{ form.oldContactor }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="联系方式" prop="oldPhone">
                <el-input v-model="form.oldPhone" disabled style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>联系方式: {{ form.oldPhone }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="详细地址" prop="oldAddress">
                <el-input v-model="form.oldAddress" disabled style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>详细地址: {{ form.oldAddress }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="组织机构代码" prop="oldCreditCode">
                <el-input v-model="form.oldCreditCode" disabled style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>组织机构代码: {{ form.oldCreditCode }}</span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="组织机构代码" prop="oldCreditCode">
                <el-input v-model="form.oldCreditCode" disabled style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>组织机构代码: {{ form.oldCreditCode }}</span>
            </el-col>
            <el-col :span="12" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" prop="oldProductionRangeName" label="生产范围">
                <el-select v-model="form.oldProductionRangeName" disabled value-key="id" multiple style="width:100%">
                  <el-option v-for="item in STATIC_ProductionRanges" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>生产范围: {{ form.oldProductionRangeName.join(';') }}</span>
            </el-col>
          </el-row>

        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">生产厂家基础信息</span>
          </div>

          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="生产厂商名称" prop="name">
                <el-input v-model="form.name" :disabled="!editMode" :class="Boolean(form.oldId)&& form.name!= form.oldName? 'change-content' : ''" placeholder="请填写生产厂商名称" style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>生产厂商名称: {{ form.oldName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="生产厂商类型" prop="category">
                <el-select v-model="form.category" :disabled="!editMode" :class="Boolean(form.oldId)&& form.categoryNames!= form.oldCategoryNames? 'change-content' : ''" multiple placeholder="请选择类型" style="width:100%;">
                  <el-option v-for="item in ManufacturerCategoryOptions" :key="item.id" :label="item.name + '厂商'" :value="item.name + '厂商'"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>生产厂商类型: {{ form.oldCategory.join(';') }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="联系人" prop="contactor">
                <el-input v-model="form.contactor" :disabled="!editMode" :class="Boolean(form.oldId)&& form.contactor!= form.oldContactor? 'change-content' : ''" placeholder="请填写联系人" style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>联系人: {{ form.oldContactor }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="联系方式" prop="phone">
                <el-input v-model="form.phone" :disabled="!editMode" :class="Boolean(form.oldId)&& form.phone!= form.oldPhone? 'change-content' : ''" placeholder="请填写联系方式" style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>联系方式: {{ form.oldPhone }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="详细地址" prop="address">
                <el-input v-model="form.address" :disabled="!editMode" :class="Boolean(form.oldId)&& form.address!= form.oldAddress? 'change-content' : ''" placeholder="请填写详细地址" style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>详细地址: {{ form.oldAddress }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="组织机构代码" prop="creditCode">
                <el-input v-model="form.creditCode" :disabled="!editMode" :class="Boolean(form.oldId)&& form.creditCode!= form.oldCreditCode? 'change-content' : ''" placeholder="请填写组织机构代码" style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>组织机构代码: {{ form.oldCreditCode }}</span>
            </el-col>
          </el-row>
          <el-row>
         
            <el-col :span="12" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" prop="productionRangeName" label="生产范围">
                <el-select v-model="form.productionRangeName" :disabled="!editMode" :class="Boolean(form.oldId)&& form.productionRangeIds!= form.oldProductionRangeIds? 'change-content' : ''" value-key="id" multiple placeholder="请选择生产范围" filterable :filter-method="getProductionRanges" @change="rangeChange" style="width:100%">
                  <el-option v-for="item in STATIC_ProductionRanges" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>生产范围: {{ form.productionRangeName.join(';') }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="备注" prop="remark">
                <el-input v-model="form.remark" :disabled="!editMode" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width:100%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注: {{ form.oldRemark }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="fileInfos" label="">
                <UploadFileList label="上传附件" :fileList="form.fileInfos ? [form.fileInfos[0]] : []" btnShowType="always" :multipleFile="false" :showFileList="true" :editMode="editMode" @fileChange="filesChange"></UploadFileList>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom"><el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
      <!-- <el-button class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button class="btn primary" type="primary" v-if="editMode" v-preventReClick @click="submit">确 定</my-button> -->
    </div>
    <!-- <el-image-viewer :openViewer="dialogVisible" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" /> -->
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetManufacturerUpdateById, SaveManufacturerUpdate,
  RejectManufacturerUpdate
} from "@/api";
import {
  ManufacturerCategoryOptions,
  // LevelOptions,
  // ManufacturerCertificateOptions,
} from "@/enum";
// import Address from "@/components/address";
// import MyUpload from "@/components/my-upload";
// import ElImageViewer from "@/components/elImageViewer";
import ApproveInfo from "@/components/approve-info";
import UploadFileList from "@/components/upload-file-list";

export default {
  name: "manufacturerUpdateEdit",
  mixins: [GetDataMixin],
  components: {
    // Address,
    // MyUpload,
    // ElImageViewer,
    ApproveInfo,
    UploadFileList
  },
  data () {
    return {
      reject: RejectManufacturerUpdate,

      title: "",
      form: {},
      // 生产厂商证件类型
      // ManufacturerCertificateOptions: ManufacturerCertificateOptions,
      ManufacturerCategoryOptions: ManufacturerCategoryOptions,
      // LevelOptions: LevelOptions,
      rules: {
        name: [
          { required: true, message: "厂商名称不能为空", trigger: "blur" },
        ],
        category: [
          { required: true, message: "厂商类型不能为空", trigger: "blur" },
        ],
        sourceType:[{ required: true, message: "请选择模块", trigger: "blur" }],
        // creditCode: [
        //   { required: true, message: "社会信用代码不能为空", trigger: "blur" },
        // ],
        // contactor: [
        //   { required: true, message: "联系人不能为空", trigger: "blur" },
        // ],
        // phone: [
        //   { required: true, message: "联系电话不能为空", trigger: "blur" },
        // ],
        // productionRangeName: [
        //   { required: true, message: '请选择生产范围', trigger: 'blur' }
        // ],
      },
  
      editMode: false
    };
  },
  props: {
    // title: {
    //   type: String,
    //   default () {
    //     return ''
    //   }
    // }
  },
  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getProductionRanges('')
  },
  methods: {
    // 新建
    handleAdd () {
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetManufacturerUpdateById({ id }).then((res) => {
        this.resetForm()
        this.form = res.returnData;
        this.title = "编辑";

        this.form.categoryNames = this.form.category
        this.form.oldCategoryNames = this.form.oldCategory

        this.form.category = this.form.category.split(';')
        this.form.oldCategory = this.form.oldCategory ? this.form.oldCategory.split(';') : []
        if (this.form.productionRangeInfos) {
          let arr = this.form.productionRangeInfos.map(item => {
            var range = this.STATIC_ProductionRanges.filter(e => e.id == item.id)
            if (!range || range.length == 0) {
              this.STATIC_ProductionRanges.push(item)
            }

            return item.id * 1
          })
          this.$set(this.form, 'productionRangeName', [...arr])
        }
        if (this.form.oldProductionRangeInfos) {
          let oldArr = this.form.oldProductionRangeInfos.map(item => {
            var range = this.STATIC_ProductionRanges.filter(e => e.id == item.id)
            if (!range || range.length == 0) {
              this.STATIC_ProductionRanges.push(item)
            }

            return item.id * 1
          })
          this.$set(this.form, 'oldProductionRangeName', [...oldArr])
        }

        // this.editMode = false;
        // if (this.formMode == 2) {
        //   this.editMode = true;
        // }

        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.form.category = this.form.category.join(';')
        this.form.oldCategory = this.form.oldCategory.join(';')
      
        SaveManufacturerUpdate(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        })
          .finally(() => {
            this.$store.dispatch('SetLoading',false)
            this.form.category = this.form.category.split(';')
            this.form.oldCategory = this.form.oldCategory.split(';')
          });
      });
    },
    resetForm () {
      this.form = {
        name: "",
        state: 1,
        countryId: 0,
        provinceId: 0,
        cityId: 0,
        details: [],
        productionRangeName: [],
        productionRangeId: '',
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },
    rangeChange (val) {
      this.form['productionRangeIds'] = val ? val.join(';') : ''
    },
    // 上传附件
    filesChange (fileList) {
      this.form.fileInfos = fileList;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
